const statisticsPath = '/users';

export const getAllUsers = `${statisticsPath}/list`;
export const getNumberOfUsers = `${statisticsPath}/statistics`;
export const getDetailedStatistics = `${statisticsPath}/detailed-statistics`;
export const getPaginatedFacebookInfoList = `${statisticsPath}/facebook-info`;
export const downloadAllUsersFacebookInfo = `${statisticsPath}/facebook-info/download`;
